
import { AdminCampaign, SortOption } from "./types";

export const sortCampaigns = (campaigns: AdminCampaign[], sortOption: SortOption): AdminCampaign[] => {
  const sorted = [...campaigns];
  
  switch (sortOption) {
    case 'created_desc':
      return sorted.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    case 'created_asc':
      return sorted.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    case 'budget_desc':
      return sorted.sort((a, b) => b.total_budget - a.total_budget);
    case 'budget_asc':
      return sorted.sort((a, b) => a.total_budget - b.total_budget);
    case 'company_asc':
      return sorted.sort((a, b) => a.company_name.localeCompare(b.company_name));
    case 'company_desc':
      return sorted.sort((a, b) => b.company_name.localeCompare(a.company_name));
    case 'status_asc':
      return sorted.sort((a, b) => a.status.localeCompare(b.status));
    case 'status_desc':
      return sorted.sort((a, b) => b.status.localeCompare(a.status));
    case 'devices_desc':
      return sorted.sort((a, b) => b.total_devices - a.total_devices);
    case 'devices_asc':
      return sorted.sort((a, b) => a.total_devices - b.total_devices);
    default:
      return sorted;
  }
};

export const getSortLabel = (option: SortOption, language: string) => {
  if (language === 'ar') {
    switch (option) {
      case 'created_desc': return 'الأحدث أولاً';
      case 'created_asc': return 'الأقدم أولاً';
      case 'budget_desc': return 'الميزانية (الأعلى أولاً)';
      case 'budget_asc': return 'الميزانية (الأقل أولاً)';
      case 'company_asc': return 'اسم الشركة (أ-ي)';
      case 'company_desc': return 'اسم الشركة (ي-أ)';
      case 'status_asc': return 'الحالة (أ-ي)';
      case 'status_desc': return 'الحالة (ي-أ)';
      case 'devices_desc': return 'عدد الأجهزة (الأكثر أولاً)';
      case 'devices_asc': return 'عدد الأجهزة (الأقل أولاً)';
      default: return option;
    }
  }
  
  switch (option) {
    case 'created_desc': return 'Newest First';
    case 'created_asc': return 'Oldest First';
    case 'budget_desc': return 'Budget (Highest First)';
    case 'budget_asc': return 'Budget (Lowest First)';
    case 'company_asc': return 'Company Name (A-Z)';
    case 'company_desc': return 'Company Name (Z-A)';
    case 'status_asc': return 'Status (A-Z)';
    case 'status_desc': return 'Status (Z-A)';
    case 'devices_desc': return 'Devices (Most First)';
    case 'devices_asc': return 'Devices (Least First)';
    default: return option;
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "approved": return "bg-emerald-500 text-white";
    case "rejected": return "bg-red-500 text-white";
    case "pending": return "bg-amber-500 text-white";
    case "completed": return "bg-blue-500 text-white";
    default: return "bg-gray-500 text-white";
  }
};

export const getStatusText = (status: string, language: string) => {
  if (language === 'ar') {
    switch (status) {
      case "approved": return "موافق عليها";
      case "rejected": return "مرفوضة";
      case "pending": return "في انتظار المراجعة";
      case "completed": return "مكتملة";
      default: return status || "غير معروف";
    }
  }
  
  switch (status) {
    case "approved": return "Approved";
    case "rejected": return "Rejected";
    case "pending": return "Pending Review";
    case "completed": return "Completed";
    default: return status || "Unknown";
  }
};

export const getPaymentTypeText = (paymentType: string, language: string) => {
  if (language === 'ar') {
    switch (paymentType) {
      case 'immediate': return 'فوري';
      case 'bank_transfer': return 'تحويل بنكي';
      case 'purchase_order': return 'أمر شراء';
      default: return 'غير محدد';
    }
  }
  
  switch (paymentType) {
    case 'immediate': return 'Immediate';
    case 'bank_transfer': return 'Bank Transfer';
    case 'purchase_order': return 'Purchase Order';
    default: return 'Not specified';
  }
};

export const getPaymentTypeColor = (paymentType: string) => {
  switch (paymentType) {
    case 'immediate': return 'text-emerald-600';
    case 'bank_transfer': return 'text-blue-600';
    case 'purchase_order': return 'text-purple-600';
    default: return 'text-gray-600';
  }
};
